<div class="video-wrapper">
    <video #videoPlayer class="video-player" controls [src]="data?.presignedUrl" preload="metadata">
    </video>
  <div class="video-actions">

    <button
      type="button"
      class="action-button"
      (click)="download()"
      title="Download">

      <span>⬇</span>
    </button>

    <button
      type="button"
      class="action-button"
      (click)="fullscreen(videoPlayer)"
      title="Full screen">

      <span>⛶</span>
    </button>

  </div>

</div>